var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6875 46.0166C85.5708 30.2041 71.6833 18.3333 55 18.3333C41.7542 18.3333 30.25 25.85 24.5208 36.85C10.725 38.3166 0 50.0041 0 64.1666C0 79.3375 12.3292 91.6666 27.5 91.6666H87.0833C99.7333 91.6666 110 81.4 110 68.75C110 56.65 100.604 46.8416 88.6875 46.0166ZM87.0834 82.5H27.5C17.3708 82.5 9.16668 74.2959 9.16668 64.1667C9.16668 54.7709 16.1792 46.9334 25.4833 45.9709L30.3875 45.4667L32.6792 41.1125C37.0333 32.725 45.5583 27.5 55 27.5C67.0083 27.5 77.3667 36.025 79.7042 47.8042L81.0792 54.6792L88.0917 55.1834C95.2417 55.6417 100.833 61.6459 100.833 68.75C100.833 76.3125 94.6459 82.5 87.0834 82.5ZM36.6667 59.5834H48.3542V73.3334H61.6458V59.5834H73.3334L55 41.25L36.6667 59.5834Z",
    fill: "#87A6BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.5607b1f9.svg";
export { ForwardRef as ReactComponent };